import { render } from "./Children.vue?vue&type=template&id=ae83109e&scoped=true"
import script from "./Children.vue?vue&type=script&lang=js"
export * from "./Children.vue?vue&type=script&lang=js"

import "./Children.vue?vue&type=style&index=0&id=ae83109e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae83109e"]])

export default __exports__